import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = ['Alle 9 complete werkboeken, van 6 tot 16 jaar', 'Theorie, oefeningen en evaluaties in elk volume', 'Simpele stap-voor-stap traininstructies', 'Kant-en-klare toetsen, projecten en antwoordsleutels', 'Printklaar én digitaal klaar — per unit, per maand of per seizoen te gebruiken', 'Alle 5 exclusieve bonussen, direct inbegrepen'];
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-94" data-mp="1reoohi0l1b0w">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-95" data-mp="1rg84r8m8nm2o">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange/15 text-brand-orange" data-id="element-96" data-mp="25cde135lh6ca">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-97" data-mp="20cqygn2ane0b" />
        </div>
        <h2 className="mb-12 text-3xl font-black text-brand-green md:text-4xl" data-id="element-98" data-mp="b05l1vcu2zj5">
          ⚡ Wat Krijg Je Direct?
        </h2>
        <div className="space-y-3 text-left" data-id="element-99" data-mp="62x23sjv2rgu">
          {items.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5 shadow-sm" data-id="element-100" data-mp="2n3hzf70lterf">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-moss" aria-hidden="true" data-id="element-101" data-mp="2wytexrju6q08" />
              <span className="font-semibold" data-id="element-102" data-mp="31se6p1uu6nqz">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-bold italic text-brand-goldink" data-id="element-103" data-mp="35uiwfpi5z08c">
          Je hebt nooit meer materiaal tekort.
        </p>
      </Reveal>
    </section>;
}